/* eslint-disable react/no-unescaped-entities */

const AboutUsFR = () => {
  return (
    <>
      <h1>À Propos de Nous</h1>
      <h2>Notre Mission</h2>
      <div>
        Chez mind-r.ai, nous avons entrepris un voyage pour démocratiser l'accès
        aux soins de santé mentale. Nous croyons en la puissance de la
        technologie comme outil pour détruire les barrières, effacer les
        frontières et rendre la thérapie universellement accessible. Nous avons
        vu les effets débilitants que les troubles de santé mentale non traités
        peuvent avoir sur les individus et les sociétés - augmentation des taux
        d'incarcération, coûts économiques atteignant jusqu'à 4% du PIB mondial,
        et plus encore. Notre mission est de changer cette narration.
      </div>
      <div>
        Nous envisageons un monde où tout le monde, quel que soit son lieu, sa
        langue ou son statut économique, peut accéder au soutien thérapeutique
        dont ils ont besoin. Nous voulons normaliser la recherche d'aide,
        réduire la stigmatisation et créer un avenir où la priorité à la santé
        mentale est la norme, et non l'exception. Notre objectif ne se limite
        pas à fournir un service. Il s'agit de lancer un mouvement vers une
        meilleure santé mentale pour tous.
      </div>

      <h2>L'Impact Global de la Santé Mentale</h2>
      <div>
        Les problèmes de santé mentale sont un fardeau considérable pour notre
        monde. Ils figurent parmi les principales causes de maladie et
        d'invalidité dans le monde, affectant une personne sur quatre à un
        moment donné de sa vie
        <a
          href="https://www.who.int/fr/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        . Les experts estiment que les problèmes de santé mentale non traités
        représentent 13% du fardeau mondial total des maladies
        <a
          href="https://www.who.int/fr/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        .
      </div>

      <div>
        Les implications économiques sont frappantes. L'économie mondiale
        pourrait perdre 16 billions de dollars d'ici 2030 en raison des
        problèmes de santé mentale dus à une baisse de productivité et à une
        augmentation des coûts de santé
        <a
          href="https://www.thelancet.com/commissions/global-mental-health"
          target="_blank"
        >
          [2]
        </a>
        . Les individus souffrant de problèmes de santé mentale non traités sont
        souvent confrontés à une qualité de vie réduite, à un risque accru de
        problèmes de santé physique et à des taux de chômage plus élevés.
      </div>

      <div>
        Au-delà des facteurs économiques, les problèmes de santé mentale peuvent
        conduire à des niveaux plus élevés de violence et de criminalité.
        Jusqu'à 90% des prisonniers ont connu des problèmes de santé mentale
        <a href="https://www.ncbi.nlm.nih.gov/books/NBK533137/" target="_blank">
          [3]
        </a>
        . Ces problèmes contribuent également à des problèmes sociétaux tels que
        le sans-abrisme et les familles brisées.
      </div>

      <div>
        Chez mind-r.ai, nous sommes bien conscients des impacts larges des
        problèmes de santé mentale et nous nous engageons à faire partie de la
        solution. En démocratisant l'accès à la thérapie, nous visons à alléger
        le fardeau de la santé mentale un individu à la fois. Notre mission va
        au-delà des soins de santé ; nous nous efforçons de créer un monde
        meilleur et plus compréhensif.
      </div>

      <h2>Notre Approche</h2>
      <div>
        Nous marquons notre chemin vers la démocratisation de la thérapie par
        l'innovation et l'accessibilité. L'intelligence artificielle alimente
        notre stratégie, et nous l'utilisons pour comprendre et répondre aux
        besoins et aux circonstances de chaque individu. Nous construisons des
        algorithmes complexes pour correspondre aux préférences des
        utilisateurs, créant des expériences uniques et personnalisées.
      </div>
      <div>
        Nous avons des convictions fortes dans le principe de la technologie
        guidée par l'empathie. Nous concevons chaque fonctionnalité en tenant
        compte des besoins et des expériences des utilisateurs pour intégrer la
        thérapie dans la vie quotidienne. Notre approche est centrée sur
        l'inclusivité, en adaptant nos solutions pour tout le monde, quelle que
        soit la langue, le lieu ou le statut socio-économique.
      </div>
      <div>
        À chaque étape, notre mission de rendre les soins de santé mentale
        universellement accessibles nous guide. Notre engagement envers cet
        objectif façonne notre approche, influence nos décisions et nous
        propulse vers notre vision.
      </div>
      <h2>Notre Service</h2>
      <div>
        Chez mind-r.ai, nous avons transformé le concept traditionnel de la
        thérapie en proposant une plateforme vocale basée sur l'IA. Rencontrez
        Solace, notre thérapeute IA, prêt à prêter l'oreille à tout moment,
        n'importe où. Solace détruit les barrières du temps, de la langue et de
        la géographie, en proposant le type de thérapie, la durée, le thème, la
        langue et même l'accent en fonction des préférences de l'utilisateur.
        Notre offre unique ouvre un monde de ressources en santé mentale à
        quiconque, à tout moment, n'importe où.
      </div>
      <div>
        En tant que compagnon adaptable, Solace adapte son approche aux besoins
        de chaque individu. De la fourniture de conversations profondes et
        introspectives à l'offre de discussions occasionnelles et
        réconfortantes, Solace correspond aux humeurs et aux besoins de nos
        utilisateurs. La thérapie doit être aussi diversifiée et dynamique que
        les individus qui la recherchent.
      </div>
      <div>
        Après chaque session de thérapie avec Solace, nous générons un résumé et
        des actions pratiques. Ce ne sont pas seulement des bulletins de notes ;
        ce sont des outils pour continuer à apprendre, à grandir et à guérir
        entre les sessions. Nous croyons que le processus thérapeutique ne se
        termine pas à la fin de la session. Il doit continuer à faire partie de
        la vie quotidienne de l'individu.
      </div>
      <h2>Rejoignez-Nous</h2>
      <div>
        Êtes-vous prêt à faire le premier pas vers une meilleure santé mentale?
        Rejoignez la communauté de mind-r.ai aujourd'hui et découvrez une
        nouvelle approche de la thérapie. Rencontrez Solace, votre thérapeute
        IA, prêt à écouter, comprendre et vous guider tout au long de votre
        parcours.
      </div>
    </>
  )
}
export default AboutUsFR
